import { IBanner } from '~/src/api/content/banners';
import { BannerRoutersCardBlock } from '~/src/features/equipment/pageBlocks/BannerRoutersCardBlock';

import * as ST from './styled';

interface IProps {
    banners: IBanner[],
}

const BannerWithRoutersCard = ({ banners }: IProps): JSX.Element => (
    <ST.Wrapper>
        {banners.map((banner) => (
            <BannerRoutersCardBlock
                key={banner.banner}
                bannerWithRouters={banner}
            />
        ))}
    </ST.Wrapper>
);

export default BannerWithRoutersCard;
